import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ActivityTemplateInterface } from "../../Entity/Entities/Activity/ActivityTemplateInterface";
import Translator from "../../Translation/Translator";

export default function* activityTemplateDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_DELETE_REQUEST
    });

    yield call(Http.delete, `activity-templates/${action.payload?.activityTemplate.id}`);

    const activityTemplate: ActivityTemplateInterface = action.payload?.activityTemplate.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_DELETE_SUCCESS,
      payload: {
        activityTemplate: activityTemplate
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-activity-template-removed-successfully"),
        type: "success"
      }
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_ACTIVITY_TEMPLATE_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchActivityTemplateDelete() {
  yield takeEvery(Constants.GLOBAL_ACTIVITY_TEMPLATE_DELETE_START, activityTemplateDelete);
}
